// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__VWAB3","Menu":"Sidebar_Menu__tz807","Counter":"Sidebar_Counter__OQQwi","active":"Sidebar_active__XPsmf"};